<template>
  <div>
    <div class="contianer">
      <div class="cardContainerSite">
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgGreen" />
          </van-col>
          <van-col span="22">
            <div>
              <van-field placeholder="请输入上车点" readonly="readonly"  v-model="userData.startAddress"  />
            </div>
          </van-col>
        </van-row>
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgRed" />
          </van-col>
          <van-col span="22">
            <div>
              <van-field placeholder="请输入目的地" readonly="readonly"   v-model="userData.endAddress" />
            </div>
          </van-col>
        </van-row>
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgUser" />
          </van-col>
          <van-col span="22">
            <div>
              <van-field placeholder="请输入乘车人数" readonly="readonly"   v-model="userData.number" />
            </div>
          </van-col>
        </van-row>
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgTime" />
          </van-col>
          <van-col span="22">
            <div class="flex">
              <van-field placeholder="请选择用车时间段" readonly="readonly"   v-model="userData.time" />
              <span class='element-money'>¥{{userData.estimateMoney}}</span>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    userData:{
      type:Object
    }
  },
  data() {
    return {
      imgUrl: require("../../assets/home/index-banner.png"),
      imgRed: require("../../assets/home/yuan-red.png"),
      imgGreen: require("../../assets/home/yuan-green.png"),
      imgUser: require("../../assets/home/user.png"),
      imgTime: require("../../assets/home/time.png"),
      value:'84684adsfafd'
    };
  }
};
</script>
<style lang="scss" scoped>
$gray32:#323233;
.contianer{
  .cardContainerSite{
    padding-top:30px;
    padding-bottom:30px;
    padding-left:30px;
    padding-right:30px;
    .van-cell{
      padding-top:0;
      padding-bottom:0;
      padding-left:10px;
      height:80px;
      line-height:80px;
    }
  }
}
.van-cell::after{
  border:none;
}
.element-money{
    color:$gray32;
    font-size:36px;
    font-weight: 500;
}
</style>